var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpmgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92.4 36.9",
    style: {
      enableBackground: "new 0 0 92.4 36.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    className: "st0",
    d: "M71.9,0L71.9,0v18.4c-0.7,0.5-1.2,1-1.7,1.7V0H49.7v16.7H48V0H27.5v16.8h-1.7V0H5.2v19.1L0,36.4h4.6l2.3-7.7 h0.7l3.8,7.7H17l-3.7-7.7h8.4l-2.3,7.7h5l2.3-7.6h1.1v0h1.6h0.1H39l-2.2,7.6h5.1l2.2-7.6h2.3l0.1,7.6h4.3l4.9-7.6h3.2L57,36.4h5 l1.6-7.6h2.9c-0.1,2.4,0.5,4.5,2.1,6c1.9,1.8,4.9,2.1,7.1,2.1c3,0,6.1-0.4,9.3-1.1l1.7-7h5.6V0H71.9z M25,17.8l-0.3,1l-2.7,9 l-0.1,0.3h-9l-0.7-1.5l9.7-9.8h-6.2l-7.6,8.1l2.4-8.1H5.9v-16h19V17.8z M30.3,25.4c-0.2,0-0.4,0-0.6,0H29h-1.2l0.6-2.1l0.3-1 l0.7-2.4h0.8H31c1.6,0,2.6,0.1,3,0.6c0.3,0.4,0.3,1.1-0.1,2.1C33.4,24.3,32.6,25.2,30.3,25.4z M44.2,28.1l2-7.1l0.1,7.1H44.2z  M47.3,16.8L47.3,16.8h-4.8l-3.3,11.3h-5.1c2.6-0.9,4.1-2.8,4.6-5.4c0.4-2.1,0.2-3.5-0.7-4.5c-1.3-1.5-3.8-1.4-6.1-1.4h-3.8v-16h19 V16.8z M58.8,28.1h-2.9l4.3-6.8L58.8,28.1z M69.5,17.1L69.5,17.1l0,3.9c-1.3,1.8-2.2,3.8-2.5,5.4c-0.1,0.5-0.3,1.1-0.3,1.7h-2.8 l2.4-11.3h-8.1l-7.2,11.3h-0.5V0.7h19.1V17.1z M80.4,32.7c-1.1,0.2-2.2,0.3-3.2,0.3c-2.7,0-4.7-1.3-4.7-4.2h8.9L80.4,32.7z  M91.7,28.1h-4.8l0.8-3.1H78l-0.8,3.1h-4.7v-0.6c0.1-0.4,0.1-0.7,0.2-1.1c0.8-3.4,3.1-6.8,7-6.8c1.5,0,3.1,0.6,2.9,2.7h5.7 c0.2-1,0.6-2.7-0.5-4.2c-1.2-1.7-3.7-2.4-6.9-2.4c-2.3,0-5.6,0.4-8.4,2.2V0.7h19.1V28.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpmgLogoWhite);
export default __webpack_public_path__ + "static/media/kpmg-logo-white.e7998ed4d2facc401f3b70db89f04406.svg";
export { ForwardRef as ReactComponent };